import { useEffect, useRef } from "react";

export function useIsSticking<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (!ref.current) return;
    const listener = () => {
      const element = ref.current;
      if (!element) return;
      const stickyElementStyle = window.getComputedStyle(element);
      const stickyElementTop = parseInt(stickyElementStyle.top, 10);
      const currentTop = element.getBoundingClientRect().top;

      if (currentTop <= stickyElementTop) {
        element.dataset.stick = "true";
      } else {
        element.dataset.stick = "false";
      }
    };
    window.addEventListener("scroll", listener);
    return () => window.removeEventListener("scroll", listener);
  }, []);
  return { ref, isSticking: ref.current?.dataset.stick === "true" };
}
